export const CURRENCY_SYMBOLS = {
  GBP: "\u00a3",
  USD: "$",
  EUR: "\u20ac",
  NGN: "\u20a6",
  GHS: "GH\u20b5",
  KES: "KSh",
  ZAR: "R",
};

export const CURRENCIES = ["GBP", "USD", "EUR", "NGN", "GHS", "KES", "ZAR"];

export function fmtMoney(n, currency = "USD") {
  const v = Number(n || 0);
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  const sym = CURRENCY_SYMBOLS[currency] || "";
  return `${sign}${sym}${abs}`;
}
